import className from 'classnames/bind';
import styles from './ToastItem.module.scss';
import { NetspendContext } from 'library/contexts/NetspendContext';
import { useContext } from 'react';

let cx = className.bind(styles);

export default function ToastItem({ message, type, id }) {
	const { setToastData } = useContext(NetspendContext);
	const autoCloseDuration = 5;

	const removeToast = (id) => {
		setToastData((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
	};

	setTimeout(() => {
		removeToast(id);
	}, (autoCloseDuration + .3) * 1000);  //.3 seconds is the animation time

	return (
		<output className={cx(['ns_toast', 'toast', type])} role="status">
			{message}
		</output>
	);
}
